"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionSeparator = void 0;

var _react = _interopRequireDefault(require("react"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Text = _interopRequireDefault(require("@jobmatchme/ui/es/components/Text"));

var _Headline = _interopRequireDefault(require("@jobmatchme/ui/es/components/Headline"));

var _useOurTranslation = require("../../utils/useOurTranslation");

var _SeparatorSymbol = _interopRequireDefault(require("@jobmatchme/ui/es/components/SeparatorSymbol/"));

var _Button = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/Button"));

var _Funnel = require("../Funnel");

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var SectionSeparatorComponent = function SectionSeparatorComponent(_ref) {
  var config = _ref.config,
      totalStepsNumber = _ref.totalStepsNumber;
  var t = (0, _useOurTranslation.useComponentTranslation)(config);

  var _useFunnelActions = (0, _Funnel.useFunnelActions)(),
      next = _useFunnelActions.next,
      skip = _useFunnelActions.skip;

  var translations = config.translations || {
    text: '',
    hint: ''
  };

  var Content = function Content() {
    var primary = _styleModule.default.primary;
    var background = _styleModule.default.dark;
    var secondary = _styleModule.default.secondary;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      className: "".concat(_styleModule.default.sectionSeparator, " ").concat(_styleModule.default[config.discriminator || 'jmm']),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        container: true,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
          item: true,
          xs: 12,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
            className: _styleModule.default.SeparatorSymbol,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SeparatorSymbol.default, {
              width: '100px',
              height: '100px',
              background: background,
              primary: primary,
              secondary: secondary
            })
          }), config.target === 'pc' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
              item: true,
              xs: 12,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Headline.default, {
                variant: 2,
                size: 2,
                center: true,
                className: _styleModule.default.headline,
                children: t(translations.text)
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
                className: _styleModule.default.text,
                children: t(translations.description)
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
              item: true,
              xs: 12,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
                className: _styleModule.default.funnelPos,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
                  color: "success",
                  className: _styleModule.default.funnelbutton,
                  variant: "contained",
                  round: true,
                  flat: true,
                  texttransform: "none",
                  onClick: function onClick() {
                    return next();
                  },
                  children: t(translations.nextButton)
                })
              })
            })]
          }) : '', config.target === 'bc' && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
              item: true,
              xs: 12,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Headline.default, {
                variant: 1,
                size: 1,
                center: true,
                className: "".concat(_styleModule.default.dashboardHeadline, " ").concat(config.currentSection === 3 ? _styleModule.default.activeHeadline : ''),
                children: t(translations.text)
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Headline.default, {
                variant: 3,
                size: 3,
                className: _styleModule.default.dashboardText,
                children: t(translations.description)
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
              item: true,
              xs: 12,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
                className: _styleModule.default.centerText,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
                  color: "dark",
                  className: _styleModule.default.dashboardButton,
                  variant: "contained",
                  round: true,
                  flat: true,
                  texttransform: "none",
                  onClick: function onClick() {
                    next();
                  },
                  children: t(translations.nextButton)
                })
              })
            }), translations.skipButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
              item: true,
              xs: 12,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Headline.default, {
                  variant: 4,
                  size: 4,
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
                    onClick: function onClick() {
                      return skip(config.currentSection + 1);
                    },
                    className: _styleModule.default.dashboardLink,
                    children: t(translations.skipButton)
                  })
                })
              })
            })]
          })]
        })
      })
    });
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Content, {});
};

var SectionSeparator = SectionSeparatorComponent;
exports.SectionSeparator = SectionSeparator;